import React from 'react'
// @ts-ignore
import Fade from 'react-reveal/Fade';

type IProps = React.PropsWithChildren

export const PointTitle = (props: IProps) => {
  return (
    <Fade left cascade duration={500} distance="40px">
      <h3 className="pointtitle">
        <p className="pointtitle__point" translate='no'>POINT</p>
        <p className="pointtitle__text" translate='no'>{props.children}</p>
      </h3>
    </Fade>
  )
}